import dayjs from 'dayjs';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';
import { graduationStatus } from '@/shared/constants/graduation';
import { GraduationType } from '@/types/graduation';

export const GraduationColumns = (
  t: any,
  onEditGraduation?: (data: GraduationType) => void,
  onEditStatusGraduation?: (isActive: boolean, rowData: GraduationType) => void,
): ColumnDescription[] => [
  {
    dataField: 'period_number',
    text: t('graduation_list.id'),
    headerClassname: 'text-center min-w-[100px]',
    classname: 'min-w-[100px] text-gray-700 text-center',
  },
  {
    dataField: 'learning_start_date',
    text: t('graduation_list.learning_start_date'),
    headerClassname: 'min-w-[180px]',
    classname: 'min-w-[180px]',
    sort: true,
    formatter: (rowData) => {
      return <div>{rowData.learning_start_date || '-'}</div>;
    },
  },
  {
    dataField: 'due_public_date',
    text: t('graduation_list.start_date'),
    headerClassname: 'min-w-[180px]',
    classname: 'min-w-[180px]',
    sort: true,
    formatter: (rowData) => {
      return <div>{rowData.due_public_date || '-'}</div>;
    },
  },
  {
    dataField: 'terms',
    text: t('graduation_list.coach_payment_setting'),
    headerClassname: 'min-w-[260px]',
    classname: 'min-w-[260px]',
    sort: false,
    formatter: (rowData: GraduationType) => {
      if (!rowData.terms || rowData.terms.length === 0) {
        return <div>-</div>;
      }

      return (
        <div className="flex flex-col gap-1">
          {rowData.terms.map((term) => (
            <div key={term.id ?? term.name}>
              {t('graduation_list.coach_authority_available')} :{' '}
              {term.trial_end_date ? term.trial_end_date : '-'}{' '}
              - {t('graduation_list.start_date_charging')}:{' '}
              {term.due_payment_date ? term.due_payment_date : '-'}{' '}
              - {t('graduation_list.status')}:{' '}
              {term.status === graduationStatus.OPEN
                ? t('graduation_list.status_active')
                : term.status === graduationStatus.IN_PROGRESS
                  ? t('graduation_list.status_in_progress')
                  : term.status === graduationStatus.CLOSED
                    ? t('graduation_list.status_completed')
                    : term.status || '-'}
            </div>
          ))}
        </div>
      );
    },
  },
  {
    dataField: 'created_at',
    text: t('graduation_list.created_date'),
    headerClassname: 'min-w-[180px]',
    classname: 'min-w-[180px] text-gray-700',
    sort: true,
    formatter: (rowData) => (
      <div>
        {rowData.created_at
          ? dayjs(rowData.created_at.toString()).format('YYYY/MM/DD')
          : '-'}
      </div>
    ),
  },
  {
    dataField: 'status',
    text: t('graduation_list.status'),
    headerClassname: 'text-center',
    sort: true,
    formatter: (rowData) => (
      <div className="w-full flex justify-center">
        {rowData.status === graduationStatus.OPEN && (
          <div className="rounded-2xl bg-success-50 text-success-700 text-md font-medium leading-4 w-[69px] h-[24px] flex justify-center items-center">
            {t('graduation_list.status_active')}
          </div>
        )}

        {rowData.status === graduationStatus.IN_PROGRESS && (
          <div className="rounded-2xl bg-warning-50 text-warning-500 text-md font-medium leading-4 w-[66px] h-[24px] flex justify-center items-center">
            {t('graduation_list.status_in_progress')}
          </div>
        )}

        {rowData.status === graduationStatus.CLOSED && (
          <div className="rounded-2xl bg-[#FAFAF9] text-[#44403C] text-md font-medium leading-4 w-[52px] h-[24px] flex justify-center items-center">
            {t('graduation_list.status_completed')}
          </div>
        )}
      </div>
    ),
  },
  {
    dataField: 'action',
    text: '',
    sort: false,
    classname: 'text-center w-[100px] [&>div]:justify-center',
    headerClassname: 'w-[100px] [&>div]:justify-center',
    formatter: (rowData) => (
      <div className="flex flex-row h-[36px] justify-center items-center gap-8">
        <InputSwitch
          checked={rowData.is_visible}
          onChange={(e) => onEditStatusGraduation?.(e.value, rowData)}
        />
        <Button
          className="p-[5px] w-[38px] flex justify-center items-center"
          onClick={() => onEditGraduation?.(rowData)}
        >
          <span className="pi pi-pencil" />
        </Button>
      </div>
    ),
  },
];
